import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { ClipboardList, Clock5, Database, FileText, Layers, LifeBuoy, } from 'lucide-react';
import { Separator } from '../../components/Separator';
import { Sidebar, SidebarContent } from '../../components/Sidebar';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { route } from '../../utils';
import MenuItemGroup from './components/MenuItemGroup';
import SingleMenuItem from './components/SingleMenuItem';
export function AppSidebar() {
    const { value: isSMSTemplateEnabled } = useFeatureFlag('isSMSTemplateEnabled', false);
    const { value: isEmailTemplateEnabled } = useFeatureFlag('isEmailTemplateEnabled', false);
    const { value: isDashboardEnabled } = useFeatureFlag('isDashboardEnabled', false);
    const { value: isSMSHistoryEnabled } = useFeatureFlag('isSMSHistoryEnabled', false);
    const { value: isEmailHistoryEnabled } = useFeatureFlag('isEmailHistoryEnabled', false);
    const { value: isExtraMenuEnabled } = useFeatureFlag('isExtraMenuEnabled', false);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const navMain = useMemo(() => [
        [
            ...(isDashboardEnabled
                ? [
                    {
                        title: 'Dashboard',
                        path: route('/'),
                        icon: Database,
                    },
                ]
                : []),
            {
                ...(isSMSTemplateEnabled || isEmailTemplateEnabled
                    ? {
                        title: 'Templates',
                        icon: FileText,
                        subItems: [
                            {
                                ...(isSMSTemplateEnabled && {
                                    title: 'SMS',
                                    path: route('/templates/sms'),
                                }),
                            },
                            {
                                ...(isEmailTemplateEnabled && {
                                    title: 'Email',
                                    path: route('/templates/emails'),
                                }),
                            },
                        ].filter((item) => !isEmpty(item)),
                    }
                    : []),
            },
            {
                ...((isSMSHistoryEnabled || isEmailHistoryEnabled) && {
                    title: 'History',
                    icon: Clock5,
                    subItems: [
                        {
                            ...(isSMSHistoryEnabled && {
                                title: 'SMS',
                                path: route('/history/sms'),
                            }),
                        },
                        {
                            ...(isEmailHistoryEnabled && {
                                title: 'Email',
                                path: route('/history/email'),
                            }),
                        },
                    ].filter((item) => !isEmpty(item)),
                }),
            },
        ].filter((item) => !isEmpty(item)),
        ...(isExtraMenuEnabled
            ? [
                [
                    {
                        title: 'Docs',
                        path: route('/docs'),
                        icon: ClipboardList,
                    },
                    {
                        title: 'Components',
                        path: route('/components'),
                        icon: Layers,
                    },
                    {
                        title: 'Help',
                        path: route('/help'),
                        icon: LifeBuoy,
                    },
                ],
            ]
            : []),
    ], [
        isDashboardEnabled,
        isSMSTemplateEnabled,
        isEmailTemplateEnabled,
        isSMSHistoryEnabled,
        isEmailHistoryEnabled,
        isExtraMenuEnabled,
    ]);
    return (_jsx(Sidebar, { className: "bg-white", children: _jsx(SidebarContent, { className: "gap-2 px-1 py-6", children: navMain.map((navItem, index) => (_jsxs(Fragment, { children: [navItem.map((item, idx) => item.subItems ? (_jsx(MenuItemGroup, { title: item.title, subItems: item.subItems, icon: item.icon }, idx)) : (_jsx(SingleMenuItem, { title: item.title, path: item.path, icon: item.icon }, idx))), index !== navMain.length - 1 && _jsx(Separator, { className: "my-6" })] }, index))) }) }));
}
